import React from 'react'
import { Grid, Column, ContainedListItem } from '@carbon/react'
import { ArrowRight } from '@carbon/icons-react'
import Typography from '../../components/Basics/Typography'
import { getDataLocalStorage } from '../../config/store/utils'
import LinkComponent from '../../components/Basics/Link.container'

const CustomLinkComponent = ({ title, route }) => {
  return (
    <LinkComponent route={route ?? "#"}>
      <ContainedListItem>
        <Typography
          className='cds--type-helper-text-01 link contained-list-text'
          justify='flex-start'
          display='flex'
          cursor='pointer'
        >
          {title}
          <ArrowRight size={16} />
        </Typography>
      </ContainedListItem>
    </LinkComponent>
  )
}

/**
 * The Dashboard's component
 */
const Dashboard = ({ children }) => {
  // const storedPaths = getDataLocalStorage('visitedPaths').reverse()

  return (
    <Grid fullWidth narrow>
      <Column lg={100}>
        {children}
      </Column>
    </Grid>
  )
}

export default Dashboard
